module.exports = __webpack_public_path__ + "static/media/team25.fd65a5ea.png";